module.exports = __webpack_public_path__ + "static/media/ss2020_galio_lux_1920x1080.f528fbf7.mp4";